export type SidebarVariant = 'full' | 'rail';

/**
 * True only for the map screen ("/", the (tabs) index route) — the one
 * desktop screen whose sidebar collapses to the icon rail. Matches the
 * pathname check `useActiveTab` already uses for the same route
 * (useTabNavigation.ts).
 */
export function isMapRoute(pathname: string): boolean {
  return pathname === '/';
}
